"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOAuthRootUrl = exports.getRootUrl = exports.getBaseUrl = void 0;

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var getBaseUrl = function getBaseUrl() {
  return '/settings';
};

exports.getBaseUrl = getBaseUrl;

var getRootUrl = function getRootUrl() {
  return getBaseUrl() + "/" + _hubspot.default.get();
};

exports.getRootUrl = getRootUrl;

var getOAuthRootUrl = function getOAuthRootUrl() {
  return '/settings-oauth';
};

exports.getOAuthRootUrl = getOAuthRootUrl;